import forEachPolyfill from './components/forEachPolyfill';
import slideshow from './components/slideshow';
import headerFunc from './components/headerFunc';
import modal from './components/modal';
import smoothScrollToAnchor from './components/smoothScrollToAnchor';
import videoFunc from './components/videoFunc';
import sns from './components/sns';

document.addEventListener(
  'DOMContentLoaded',
  () => {
    const HEADER_EL = document.querySelector('.header');
    const HEADER_NAV = document.querySelector('.header__nav');
    let WINDOW_WIDTH = window.innerWidth;

    forEachPolyfill();
    slideshow('.how__anim-wrapper img');
    modal(WINDOW_WIDTH);
    smoothScrollToAnchor(HEADER_NAV);
    videoFunc();
    sns();

    window.addEventListener('scroll', () => {
      headerFunc(HEADER_EL);
    });
    
    window.addEventListener('resize', () => {
      WINDOW_WIDTH = window.innerWidth;
      modal(WINDOW_WIDTH);
    });
  },
  false
);
